export default {

  /** 接口api服务注册名称 **/
  apiServer: {
    Admin: "/api-admin", //用户权限api服务名称
    Base: "/api-base", //基础库api服务名称
    CMS: "/api-cms", //企业业务库api服务名称
    Activiti: "/api-activiti", //工作流程api服务名称
    Zuul: "/zuul", //网关 api服务名称
    Tranning: "/clouddo-tranning", // 培训服务
    mall: '/mall/m'
  },
  /**字典表调用CODE**/
  dictionary: {
    DANGEROUS_OPERATION_TYPE: "DANGEROUS_OPERATION_TYPE", //危险作业类别
    STANDARD_LEVEL: "STANDARD_LEVEL", //达标等级
    ENTERPRISE_CATEGORY: "ENTERPRISE_CATEGORY", //基础类别
    OPERATION_FORM: "OPERATION_FORM", //作业形式
    TRAINING_LEVEL: "training_task_type",
    TRAINING_INDUSTRY: "0005",
    TRAINING_POST: "training_post",
    TRAINING_TYPE: "training_type"
  },
  /**类别字典表**/
  type_dictionary: {
    OPERATING_PROCEDURES: '92793b134d4f442b9b1e0782917e395a',
  },
  /**
   * 动火作业申请 流程附件类型type
   */
  HotWork: {
    LGNITION_TASK: 'LgnitionTask', //证件key前缀
    SIGN_IMG: 'signImg', //会签签字
    SCENE_IMG: "sceneImg", //会签现场图片
    PRELIMINARY_IMG: "preliminaryImg", //初审人签字
    ON_SITE_IMG: "onSiteImg", //现场审核人签字
    WORK_IMG: 'workImg', //作业证打印
    WHEN_HOT_SIGN_IMG: 'whenHotSignImg', //结束动火签字
    WHEN_HOT_SCENE_IMG: 'whenHotSceneImg', //结束动火现场图片
    ACCEPTANCE_SIGN_IMG: 'acceptanceSignImg', //验收签字
    ACCEPTANCE_SCENE_IMG: 'acceptanceSceneImg', //验收现场图片
    //证件类型前缀
    Type: {
      FIRE_NAME: 'FIRE', //动火
      BLIND_NAME: 'BLIND', //盲板
      GROUND_NAME: 'GROUND', //动土
      LIFT_NAME: 'LIFT', //吊装
      LIMIT_NAME: 'LIMIT', //受限空间
      TEMP_NAME: 'TEMP', //临时用电安全
      HIGH_NAME: 'HIGH', //高处安全
      BROKEN_NAME: 'BROKEN', //断路安全
    },
  },

  HotWorkRole: { //动火作业角色
    ON_SITE: 37, //现场审核角色id
    ACCEPTANCE: 38, //验收（动火作业）
  },
  SystemInitRole: { //系统初始化角色
    EnterpriseAdmin: 45, //企业管理员
    SubEnterpriseAdmin: 46, //子公司管理员
  },

  Activiti: 'activiti',
  FIRE_ACTION: process.env.API_ROOT + '/api-activiti/task/createAttachment',

  RelevantExamineResultImpotUrl: process.env.API_ROOT + '/api-cms/RelevantExamineResult/importData',

  /**
   * 验证状态：进行中
   */
  VFACE_STATUS_PROCESSING: 1,
  /**
   * 验证状态：成功
   */
  VFACE_STATUS_SUCCESS: 2,
  /**
   * 验证状态：超时
   */
  VFACE_STATUS_TIME_OUT: 3
}



// WEBPACK FOOTER //
// ./src/common/constant.js